import { useEffect, type RefObject } from 'react';

type Handler = (event: MouseEvent) => void;
type CallbackFn = () => void;

export function useClickOutside<T extends HTMLElement = HTMLElement>(ref: RefObject<T>, callbackFn: CallbackFn) {
  useEffect(() => {
    const handleClickOutside: Handler = (event) => {
      //@ts-expect-error: lib.dom again
      const isBootstrapBackDrop = event.target?.closest('[class*="modal"]') !== null;

      if (ref.current && !ref.current.contains(event.target as Node) && !isBootstrapBackDrop) {
        callbackFn();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callbackFn]);
}
